import axios from '@/axios'

const state = {
    postageDiscount: {},
};

const getters = {
    getPostageDiscount: (state) => state.postageDiscount,
};

const mutations = {
    setPostageDiscount: (state, postageDiscount) => (state.postageDiscount = postageDiscount),
};

const actions = {
    async loadPostageDiscount(context, data) {
        await axios().get(`/getPostageDiscount`)
            .then(response => {
                context.commit('setPostageDiscount', response.data)
            })
    },
    async postageDiscountDeleteItem(context, item) {
        await axios().post(`/deletePostageDiscount/${item.id}`)
    },
    async postageDiscountUpdateItem(context, item) {
        await axios().post(`/updatePostageDiscount/${item.id}`, item)
    },
    async postageDiscountAddItem(context, item) {
        await axios().post(`/addPostageDiscount`, item)
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
